<template>
    <div style="background-color: #FDFBF5; color: #85371F; height: calc(100vh - 0px); overflow: hidden" class="q-gutter-y-md">
        <div style="position: relative">
            <q-img src="~assets/ui/header.svg" fit="contain" />
            <div class="sot-font" style="position: absolute; top: 25px; left: 20px;">1T Спринт</div>
        </div>
        <div style="padding: 15px; padding-top: 0" class="text-center q-gutter-y-md">
            <div class="text-weight-bold text-subtitle1">
                В качестве канала связи у Вас выбран ВКонтакте, но нам не удалось отправить Вам сообщение. Скорее всего
                у Вас отключена возможность получать сообщения от сообщества клуба СОТ.
                Нажмите кнопку «Получать уведомления» чтобы мы могли писать Вам сообщени в ВКонтакте.
            </div>
            <div>
                <iframe src="https://debug.sot.club/sot.bot/vk_app/api/request_access2.html" frameborder="0" style="height: 60px;" />
                <div>
                    После того как Вы разрешите получать сообщение ВКонтакте от Клуба СОТ - нажмите кнопку «Продолжить»
                </div>
                <DefaultButton label="Продолжить" @click="skip" style="margin-top: 20px;" />
                <!--
                <div class="text-subtitle1 cursor-pointer" @click="skip">
                    Продолжить
                </div>
                -->
            </div>
        </div>
        <div style="position: absolute; bottom: 40px; margin-left: 20px;">
            <q-img src="~assets/ui/sot-bottom.svg" height="33px" width="33px" />
        </div>
    </div>
</template>

<script>

import DefaultButton from 'components/ui/common/DefaultButton';
import { queryBot } from 'boot/axios';

export default {
    name: 'PageConfirmVk',
    components: { DefaultButton },
    mounted () {
        const { user } = this.$store.state.pages;
        this.user = user;
    },
    data () {
        return {
            user: undefined,
        };
    },
    methods: {
        skip () {
            queryBot(`delete from user_info where user_id = ${this.user.id} and type like "request-vk"`);
            window.removeEventListener('beforeunload', this.$q.onClosePage);
            this.$pages.back();
        },
    },
};
</script>

<style scoped>

</style>
